import { render, staticRenderFns } from "./AttachmentsTab.vue?vue&type=template&id=22143cc6&"
import script from "./AttachmentsTab.vue?vue&type=script&lang=js&"
export * from "./AttachmentsTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports